<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Tell us about your business' employees</h3>
                    </div>
                    <div class="card-body">

                        <div class="alert alert-info2 text-justify">
                            <i class="fas fa-info-circle mr-1 fs-15"></i> <b>Note: </b>Put '0' if none.
                        </div>

                        <p class="card-text text-justify bold">No. of paid employees as of prior year</p>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Regular Employees</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.prev_reg_emp" :class="{'is-invalid': $parent.submitting && $v.formLoan.prev_reg_emp.$error}" v-input-mask data-inputmask-mask="9999" data-inputmask-placeholder="">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Contractual Employees</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.prev_contract_emp" :class="{'is-invalid': $parent.submitting && $v.formLoan.prev_contract_emp.$error}" v-input-mask data-inputmask-mask="9999" data-inputmask-placeholder="">
                                </div>
                            </div>
                        </div>
                        <hr>
                        <p class="card-text text-justify bold">No. of paid employees at time of loan</p>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Regular Employees</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.current_reg" :class="{'is-invalid': $parent.submitting && $v.formLoan.current_reg.$error}" v-input-mask data-inputmask-mask="9999" data-inputmask-placeholder="">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Contractual Employees</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.current_contract" :class="{'is-invalid': $parent.submitting && $v.formLoan.current_contract.$error}" v-input-mask data-inputmask-mask="9999" data-inputmask-placeholder="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        minLength,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan'],
        data() {
            return {

            }
        },
        validations: {
            formLoan: {
                prev_reg_emp: {
                    required
                },
                prev_contract_emp: {
                    required
                },
                current_reg: {
                    required
                },
                current_contract: {
                    required
                },

            },
        },
        created() {
            this.evalMaxLoan();
        },
        methods: {
            evalMaxLoan() {
                // let sales = this.formLoan.annual_sale * 1;
                // if (sales < 2000000) {
                //     this.formLoan.max_loan = sales * 0.02 * 20;
                //     this.formLoan.bir = 'N';
                //     this.formLoan.permit2019 = 'B';
                //     this.formLoan.current_permit = 'B';

                // }
                // if (sales >= 2000000 && sales < 20000000) {
                //     this.formLoan.max_loan = sales * 0.0225 * 20;
                //     this.formLoan.bir = 'N';
                //     this.formLoan.permit2019 = 'M';
                //     this.formLoan.current_permit = 'M';
                // }
                // if (sales >= 20000000) {
                //     this.formLoan.max_loan = sales * 0.025;
                //     this.formLoan.bir = 'Y';
                //     this.formLoan.permit2019 = 'M';
                //     this.formLoan.current_permit = 'M';
                // }
                let original = this.formLoan.annual_sale * 1;
                let padded = this.formLoan.annual_sale * 1 * 20;
                
                if (original >= 20000000) {
                    this.formLoan.max_loan = original * 0.025;
                    this.formLoan.bir = 'Y';
                    this.formLoan.permit2019 = 'M';
                    this.formLoan.current_permit = 'M';
                    this.formLoan.tier = 3;
                } else {
                    if (padded < 2000000) {
                        this.formLoan.max_loan = padded * 0.02;
                        this.formLoan.bir = 'N';
                        this.formLoan.permit2019 = 'B';
                        this.formLoan.current_permit = 'B';

                        this.formLoan.tier = 1;
                    }
                    if (padded >= 2000000 && padded < 20000000) {
                        this.formLoan.max_loan = padded * 0.0225;
                        this.formLoan.bir = 'N';
                        this.formLoan.permit2019 = 'M';
                        this.formLoan.current_permit = 'M';

                        this.formLoan.tier = 2;
                    }
                    if (padded > 20000000) {
                        this.formLoan.max_loan = padded * 0.025;
                        this.formLoan.bir = 'Y';
                        this.formLoan.permit2019 = 'M';
                        this.formLoan.current_permit = 'M';

                        this.formLoan.tier = 3;
                    }
                }

            },

            next() {
                this.$parent.submitting = false;
                this.$parent.submitting = true;
                // this.evalMaxLoan();
                this.$v.formLoan.$touch();
                if (this.$v.formLoan.$invalid) {} else {
                    this.$emit('next');
                }
            },
        },
        computed: {

        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }
</style>